import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Popup } from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import DataGrid, { Column, Editing, Scrolling, Selection } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import IReservationDetailOccupant from "../../models/IReservationDetailOccupant";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import { } from 'devextreme-react';
import useCustomDataSource from "../../hooks/useCustomDataSource";


import { Button } from 'devextreme-react/button';
import { DateBox } from "devextreme-react";
import { CheckBox } from 'devextreme-react/check-box';
//import { columnsPopUp } from './fakeData';

export default function GestionListeArrivee() {
  const reservationFormDataSource = useCustomDataSource<IReservationDetailOccupant, IReservationDetailOccupant>({ path: "reservationDetailOccupant", primaryKey: "idReservationDetailOccupant" });
  const { selectedDataRow: selectedReservation, mode,setMode, isFieldModifier, setIsFieldModifier, setMainForm, onFieldDataChanged } = reservationFormDataSource;
  const formRef = useRef<FormRef>(null);
  const [isPopupVisible, setPopupVisibility] = useState(true);
  const [dateCourrantePop, setDateCourrantePop] = useState(new Date());
  const [selectedOrdre, setSelectedOrdre] = useState<string>("");

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  const handleChange = (value: string) => {
    setSelectedOrdre(value);
  };

  const buttonAttributes = {
    class: 'popup-depot-bouton-cta'
  }

  const checkBoxAttributes = {
    class: 'popup-depot-bouton-cta'
  }

  const togglePopup = () => {
    setPopupVisibility(!isPopupVisible);
  };

  const onCurrentDateChangeDatePop = (date: Date) => {
    // setDateCourrantePop(date)
  }

  const idSelectOptions = useMemo(() => {
    return { items: [] };
  }, []);

  return (
    <Popup
      visible={isPopupVisible}
      // visible={this.state.popupVisible}
      // onHiding={this.hideInfo}
      dragEnabled={true}
      hideOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title="Liste des arrivées"
      container=".dx-viewport"
    >
      <div className='wrapper-content-pop'>
        <div>
          <div className='wrapper-toolbar-pop'>
            <div className='popup-depot-bouton-cta'>
              <Form alignItemLabelsInAllGroups={true} formData={{}} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                <GroupItem colSpan={4}>
                  <SimpleItem key={"frm-id-select"} editorType={"dxSelectBox"}
                    editorOptions={idSelectOptions} />
                </GroupItem>
              </Form>
            </div>
            <div>
              <Button
                text="Trouver"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
            </div>
            <div>
              <Button
                text="Effacer"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
            </div>
            <div>
              <DateBox type={"date"} value={dateCourrantePop} onValueChanged={(props) => onCurrentDateChangeDatePop(props.value)} />
            </div>
          </div>
          <DataGrid
            keyExpr="ID"
            dataSource={[]}
            showBorders={true}
            defaultColumns={['Date debut', 'date de fin', 'Type unite debut', 'Type unite fin', 'plan debut', 'Plan fin']}
          />
        </div>
        {/** Footer*/}
        <div className='content-footer-pop'>
          <div className='footer-row-check-box'>
            <div style={{ display: "flex", width: "80%" }}>
              <div>
                <CheckBox defaultValue={false} elementAttr={checkBoxAttributes} />
              </div>
              <div>Afficher uniquements des clients</div>
              <div>
                <CheckBox defaultValue={false} elementAttr={checkBoxAttributes} />
              </div>
              <div>Inclure les détails de groupes</div>
              <div>
                <CheckBox defaultValue={false} elementAttr={checkBoxAttributes} />
              </div>
              <div>Afficher les commentaires</div>
              <div>
                <CheckBox defaultValue={false} elementAttr={checkBoxAttributes} />
              </div>
              <div>Afficher les numéros de téléphones et le courriel du client</div>

              {/* <div>
                <CheckBox
                  value={selectedOrdre === "option1"}
                  onValueChanged={() => handleChange("option1")}
                  text="En ordre de nom"
                  elementAttr={checkBoxAttributes}
                />
              </div>
              <div>
                <CheckBox
                  value={selectedOrdre === "option2"}
                  onValueChanged={() => handleChange("option2")}
                  text="En ordre de numéro"
                  elementAttr={checkBoxAttributes}
                />
              </div>
              <div>
                <CheckBox
                  value={selectedOrdre === "option3"}
                  onValueChanged={() => handleChange("option3")}
                  text="En ordre de date"
                  elementAttr={checkBoxAttributes}
                />
              </div >
              <div>
                <CheckBox
                  value={selectedOrdre === "option4"}
                  onValueChanged={() => handleChange("option4")}
                  text="En ordre de type d'unité"
                  elementAttr={checkBoxAttributes}
                />
              </div> */}
              <div>
                <CheckBox
                  value={selectedOrdre === 'option1'}
                  onValueChanged={() => handleChange("option1")}
                  elementAttr={checkBoxAttributes} />
              </div>
              <div onClick={() => handleChange("option1")}>En ordre de nom</div>
              <div>
                <CheckBox
                  value={selectedOrdre === 'option2'}
                  onValueChanged={() => handleChange("option2")}
                  elementAttr={checkBoxAttributes} />
              </div>
              <div onClick={() => handleChange("option2")}>En ordre de numéro</div>
              <div>
                <CheckBox
                  value={selectedOrdre === 'option3'}
                  onValueChanged={() => handleChange("option3")}
                  elementAttr={checkBoxAttributes} />
              </div>
              <div onClick={() => handleChange("option3")}>En ordre de date</div>
              <div>
                <CheckBox
                  value={selectedOrdre === 'option4'}
                  onValueChanged={() => handleChange("option4")}
                  elementAttr={checkBoxAttributes} />
              </div>
              <div onClick={() => handleChange("option4")}>En ordre de type d'unité</div>
            </div >
            <div> 0 résultats</div>
          </div >
          <div className='footer-button'>
            <div>
              <Button
                text="Consulter la facture"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
              <Button
                text="Consulter la réservation"
                type="normal"
                disabled={true}
                onClick={togglePopup}
              />
            </div>
            <div>
              <Button
                text="Imprimer"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
              <Button
                text="Fermer"
                type="normal"
                onClick={togglePopup}
              />
            </div>
          </div>
        </div >
      </div >

    </Popup >
  );
}